// store.js
import Vue from 'vue';
import API from '../../api';
import loginStore from '../../util/loginStore';

/* eslint-disable no-debugger */

let questionsStore = Vue.observable({
  categories: [],
  questions: [],
  questionWhat: -1,
  questionsAnswers: [],
  selectedAnswers: {},
  saveDate: null,
  shownQuestions: [],
  // Tag id pre-selected via URL param (e.g. /match?category=meals), without
  // the visitor having actually answered a question. Lets ad-campaign
  // traffic skip "Start Here" and land directly on the category-specific
  // follow-up question(s) (Meals, Movement Training, Mind, Monetary Goals).
  presetTagId: null,
  async created() {
    if (this.questions && this.questions.length > 0) {
      return;
    }
    let res = await API.get('profile?noAuth=true');
    if (!res) {
      return;
    }
    this.questions = [];
    this.questionsAnswers = [];
    this.selectedAnswers = {};
    if (res.errors && res.errors.length > 0) {
      this.error = res.errors[0].msg;
    } else {
      if (res.data.user && res.data.user.other && res.data.user.other.questionsAnswers) {
        this.questionsAnswers = res.data.user.other.questionsAnswers;
      }
    }
    res = await API.get('tags');
    if (res.data) {
      this.tags = res.data.tags;
      this.categories = res.data.categories;
    }
    res = await API.get('questions');
    if (res.data) {
      this.questions = res.data.questions;
      this.questionWhat = res.data.what;
      var newSelectedAnswers = {};
      for (let index = 0; index < this.questions.length; index++) {
        const question = this.questions[index];
        for (let index2 = 0; index2 < this.questionsAnswers.length; index2++) {
          const questionAnswer = this.questionsAnswers[index2];
          if (questionAnswer.question == question.text) {
            //let answers = [];
            for (let index3 = 0; index3 < question.answers.length; index3++) {
              let answer = question.answers[index3];
              if (questionAnswer.answer == answer.text) {
                if (question.multiple) {
                  if (!newSelectedAnswers[question.id]) {
                    newSelectedAnswers[question.id] = [];
                  }
                  newSelectedAnswers[question.id].push(index3);
                } else {
                  newSelectedAnswers[question.id] = index3;
                }
              }
            }
          }
          if (question.multiple && newSelectedAnswers[question.id]) {
            newSelectedAnswers[question.id].sort();
          }
        }
      }
      this.selectedAnswers = newSelectedAnswers;
      this.shownQuestions = this.shownQuestionsList();
    }
  },
  // Pre-seed a category's tag id as if the visitor had already answered
  // "Start Here" with it, and hide "Start Here" itself so they land
  // directly on that category's follow-up question(s). Does not touch
  // selectedAnswers/selectedTags(), so nothing is saved or sent to the
  // backend as a real answer - this only affects which questions render.
  presetCategoryTag(tagId) {
    // questionsStore is a shared singleton that only resets on a full page
    // reload - any answer picked (even on a different category/page) earlier
    // in the same browser session stays in selectedAnswers and would bleed
    // into this preset's filtering otherwise. An ad-campaign landing should
    // only ever be driven by the preset tag itself, so wipe prior answers.
    this.selectedAnswers = {};
    this.presetTagId = tagId;
    this.shownQuestions = this.shownQuestionsList();
  },
  clearPresetCategoryTag() {
    this.presetTagId = null;
    this.shownQuestions = this.shownQuestionsList();
  },
  selectedTags() {
    let tags = [];
    let keys = Object.keys(this.selectedAnswers);
    for (let index2 = 0; index2 < keys.length; index2++) {
      const key = keys[index2];

      let selectedAnswersToQuestion = this.selectedAnswers[key];
      let question;
      for (let index = 0; index < this.questions.length; index++) {
        const currentQuestion = this.questions[index];
        if (currentQuestion.id == key) {
          question = currentQuestion;
          break;
        }
      }

      if (typeof selectedAnswersToQuestion !== 'undefined') {
        if (Array.isArray(selectedAnswersToQuestion)) {
          for (let index2 = 0; index2 < selectedAnswersToQuestion.length; index2++) {
            const answer = question.answers[selectedAnswersToQuestion[index2]];
            for (let index6 = 0; index6 < answer.tag.length; index6++) {
              const element = answer.tag[index6];
              tags.push(element);
            }
          }
        } else {
          const answer = question.answers[selectedAnswersToQuestion];
          for (let index6 = 0; index6 < answer.tag.length; index6++) {
            const element = answer.tag[index6];
            tags.push(element);
          }
        }
      }
    }
    return tags;
  },
  loadQuestionsAnswers() {
    let res = [];
    let keys = Object.keys(this.selectedAnswers);
    for (let index2 = 0; index2 < keys.length; index2++) {
      const key = keys[index2];

      let selectedAnswersToQuestion = this.selectedAnswers[key];
      let question;
      for (let index = 0; index < this.questions.length; index++) {
        const currentQuestion = this.questions[index];
        if (currentQuestion.id == key) {
          question = currentQuestion;
          break;
        }
      }

      let answer = null;

      if (typeof selectedAnswersToQuestion !== 'undefined') {
        if (Array.isArray(selectedAnswersToQuestion)) {
          for (let index2 = 0; index2 < selectedAnswersToQuestion.length; index2++) {
            answer = question.answers[selectedAnswersToQuestion[index2]];
            res.push({ question: question.text, answer: answer.text });
          }
        } else {
          answer = question.answers[selectedAnswersToQuestion];
          res.push({ question: question.text, answer: answer.text });
        }
      }
    }
    return res;
  },
  shownQuestionsList() {
    let selectedTags = this.selectedTags();
    let selectedTagsMap = {};
    for (let index = 0; index < selectedTags.length; index++) {
      const tag = selectedTags[index];
      selectedTagsMap[tag] = tag;
    }
    if (this.presetTagId) {
      selectedTagsMap[this.presetTagId] = this.presetTagId;
    }

    let res = [];
    for (let index = 0; index < this.questions.length; index++) {
      const question = this.questions[index];

      // When a category has been pre-selected via URL param, show ONLY
      // that category's gated question(s) - skip every question that has
      // no ifTagId of its own. Confirmed against the real /api/questions
      // payload (2026-10-22): this covers "Start Here" (id 2) and
      // "Traumatic Experiences" (id 9), both ifTagId: null, meant to show
      // unconditionally on the normal flow but not on a category-preset
      // ad link. Questions that legitimately share the category's tag
      // (e.g. Cleansing, ifTagId 1, same as Meals) are intentionally kept.
      if (this.presetTagId && !question.ifTagId) {
        continue;
      }

      if (!question.hidden && (!question.ifTagId || selectedTagsMap[question.ifTagId])) res.push(question);
    }
    return res;
  },

  selectAnswer() {
    setTimeout(() => {
      if (!this.currentQuestion().multiple) {
        this.next();
      }
    }, 500);
  },
  emitSelectedTags() {
    let questionsAnswers = this.loadQuestionsAnswers();
    this.$emit('selectedTags', {
      questionsAnswers,
      selectedTags: this.selectedTags()
    });
  },
  async save() {
    let questionsAnswers = this.loadQuestionsAnswers();
    let selectedTags = this.selectedTags();
    if (loginStore.loggedIn) {
      await API.post('edit-search-info', {
        questionsAnswers,
        searchTags: selectedTags
      });
    }

    this.questionsAnswers = questionsAnswers;

    this.saveDate = new Date();
    this.shownQuestions = this.shownQuestionsList();
  },
  async questionsAnswersPrepared(questionAnswers) {
    let res = [];
    for (let index = 0; index < this.questions.length; index++) {
      const question = this.questions[index];
      for (let index2 = 0; index2 < questionAnswers.length; index2++) {
        var questionAnswer = questionAnswers[index2];
        let questionText = questionAnswer.question;
        let answerText = questionAnswer.answer;
        if (questionText == question.text) {
          for (let index3 = 0; index3 < question.answers.length; index3++) {
            let answer = question.answers[index3];
            if (answerText == answer.text) {
              if (res.length == 0 || res[res.length - 1].question.id != question.id) {
                res.push({ question, answers: [] });
              }
              res[res.length - 1].answers.push(answerText);
            }
          }
        }
      }
    }
    return res;
  }
});
export default questionsStore;
